import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';
import HrbTranslate from '../../../components/language/HrbTranslate'
import StatusBadge from '../../../components/library/badges/StatusBadge'
import MultiYearIcon from '../../../components/library/graphics/MultiYearIcon'
import LoadingText from '../../../components/library/layout/LoadingText'
import './TicketBasicInformation.scss'
import { useTicketStatus } from './hooks/useTicketStatusHook';
import { useInterviewInfo } from './hooks/useInterviewInfoHook';
import { TicketState } from '../services/TicketState';
import TicketTitle from './TicketTitle';

const TicketStatus = (props) => {
    const { ticket, lang } = props;
    const history = useHistory();

    const [isFailed, setIsFailed] = useState(false);
    const [multipleReturns, setMultipleReturns] = useState(false);

    const [stateTasks, ticketStatus] = useTicketStatus(ticket);

    const [returnType, , province] = useInterviewInfo(ticket);

    useEffect(() => {
        setIsFailed((stateTasks || []).some(t => t.status === 'Failed'))
    }, [stateTasks])

    useEffect(() => {
        setMultipleReturns(returnType === 'coupled' || province === 'QC')
    }, [returnType, province])

    const viewClientInfo = () => {
        history.push(`/clients/${ticket.targetId}`)
    }

    return (
        <Fragment>
            <TicketTitle ticket={ticket} lang={lang} />
            <div className='columns tickets level'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <div className='tax-year-holder'>
                        <h4>
                            <LoadingText
                                textKey={multipleReturns ? 'Tickets.Labels.TaxYears' : 'Tickets.Labels.TaxYear'}
                                params={{ TaxYear: ticket ? ticket.taxYear : 0 }}
                                loading={!ticket}
                                isEmpty={ticket && !ticket.taxYear} />                        
                        </h4>
                        {ticket && ticket.relatedTickets && ticket.relatedTickets.length > 0 &&
                            <Fragment>
                            <div onClick={viewClientInfo} className='show-ptr'>
                                <MultiYearIcon />
                            </div>
                            <a onClick={viewClientInfo} className={classnames({ 'is-french': lang === 'fr' || lang === 'FR'})}>
                                <HrbTranslate text='Tickets.Labels.MultiYear' />
                            </a>
                        </Fragment>
                        }
                    </div>
                </div>
                <div className='column is-6'>
                    <div className='status-holder'>
                        <h4><HrbTranslate text='Tickets.Labels.Status' /></h4>                        
                        {ticketStatus === TicketState.CLOSED &&
                            <StatusBadge
                                workflowTask='CLOSEDCOMPLETE'
                                status='completed' />
                        }
                        {ticketStatus === TicketState.CLOSED_COMPLETED_IN_OFFICE &&
                            <StatusBadge
                                workflowTask='CLOSEDCOMPLETEOFFICE'
                                status='completed' />
                        }
                        {ticketStatus === TicketState.CLOSED_INCOMPLETE &&
                            <StatusBadge
                                workflowTask='CLOSEDINCOMPLETE'
                                status='incomplete' />                        
                        }
                        {ticketStatus === TicketState.OPEN && isFailed && 
                            <StatusBadge status='Failed' />
                        }
                        {ticketStatus === TicketState.OPEN && !isFailed && stateTasks.filter(t => t.status !== 'CompletedSuccessfully').map(st => (
                            <StatusBadge
                                key={`sb_task_${st.identifier}`}
                                workflowTask={st.identifier}
                                status={st.status} 
                                ticketType={ticket?.ticketType?.identifier}/>
                        ))}
                    </div>
                </div>
                <div className='column is-1' />
            </div>
        </Fragment>
    );
}

TicketStatus.whyDidYouRender = false;

TicketStatus.propTypes = {
    ticket: PropTypes.object,
    lang: PropTypes.string
}

export default TicketStatus